import { Cookies } from "react-cookie";
import { isForceResetNeeded } from "utility/ForceResetHelper";

const cookies = new Cookies();

export const isUserLoggedIn = () => {
  return cookies.get("auth_token") && cookies.get("reauth") && !isForceResetNeeded();
};
